import React from "react";
import {
  Drawer,
  FlexboxGrid,
  Icon,
  Table,
  Tooltip,
  Whisper,
  IconButton,
} from "rsuite";
import useAdmediaryApi from "../../@Hooks/useAdmediaryApi";
import { AdmediaryContext } from "../../@Context/AdmediaryContext";
import { sort } from "../../@Utils/Sorting";
import { CurrencyCell } from "../Table";
import { format } from "date-fns";
import { exportCsv } from "../../@Utils/Export";
import Title from "../Title";
const { Column, HeaderCell, Cell } = Table;

type ViewHistory = {
  row_data: any;
};

const ViewHistory: React.FC<ViewHistory> = ({ row_data }) => {
  const Admediary = React.useContext(AdmediaryContext);
  const [sort_type, sort_sort_type] = React.useState();
  const [sort_column, set_sort_column] = React.useState();
  const lead_instance_id = 108942808 || row_data.lead_instance_id;

  const params = {
    lead_instance_id,
  };

  /**
   * @param column
   * @param type
   */
  const handleSortColumn = (column: any, type: any) => {
    set_sort_column(column);
    sort_sort_type(type);
  };

  /**
   * Rewrite list data with formatted data
   * @param list
   */
  const formatData = (list: any) => {
    return list.map((item: any) => {
      return {
        ...item,
      };
    });
  };
  /**
   * Sort handler for Rsuite tables
   * @param list
   */
  const sortData = (list: any) => {
    return formatData(
      sort_column && sort_type ? sort(list, sort_column, sort_type) : list
    );
  };

  const [data, isLoading] = useAdmediaryApi("view_history", params);

  return (
    <>
      <Drawer.Header className="buyer-sidebar-header">
        <Drawer.Title
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {Admediary.drawerFull ? (
            <Icon
              icon="window-restore"
              onClick={Admediary.restoreDrawer}
              style={{ marginTop: "3px", cursor: "pointer" }}
            />
          ) : (
            <Icon
              icon="window-maximize"
              onClick={Admediary.maximizeDrawer}
              style={{ marginTop: "3px", cursor: "pointer" }}
            />
          )}
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <Title title="View History" />
        <FlexboxGrid justify="space-between" style={{ marginBottom: 25 }}>
          <FlexboxGrid.Item colspan={24} style={{ textAlign: "right" }}>
            <IconButton
              onClick={() =>
                exportCsv(
                  `view_history_report_${format(
                    new Date(Admediary.start),
                    "MMddyy"
                  )}_${format(new Date(Admediary.end), "MMddyy")}.csv`,
                  data
                )
              }
              icon={<Icon icon="file-download" />}
              placement="right"
              size="sm"
            >
              Export
            </IconButton>
          </FlexboxGrid.Item>
        </FlexboxGrid>
        {/* <FlexboxGrid justify="space-between" style={{ marginBottom: 25 }}> */}
        {/* <FlexboxGrid.Item colspan={24} style={{ textAlign: "right" }}> */}
        <Table
          height={650}
          virtualized
          affixHeader
          affixHorizontalScrollbar
          data={Array.isArray(data) ? sortData(data) : []}
          loading={isLoading === true}
          rowClassName="clickable-data striped-rows"
          sortColumn={sort_column}
          sortType={sort_type}
          onSortColumn={handleSortColumn}
        >
          <Column width={125} fixed sortable resizable>
            <HeaderCell>
              <span>ID</span>
              <Whisper
                trigger="hover"
                speaker={<Tooltip>TRANSACTION ID</Tooltip>}
              >
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <Cell dataKey="transaction_id" />
          </Column>
          <Column sortable resizable width={200}>
            <HeaderCell>
              <span>Current Status</span>
              <Whisper
                trigger="hover"
                speaker={<Tooltip>Current Status</Tooltip>}
              >
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <Cell dataKey="current_status" />
          </Column>
          <Column sortable resizable width={150}>
            <HeaderCell>
              <span>Current Rate</span>
              <Whisper
                trigger="hover"
                speaker={<Tooltip>Current Rate</Tooltip>}
              >
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <CurrencyCell dataKey="current_rate" />
          </Column>
          <Column sortable resizable width={125}>
            <HeaderCell>
              <span>Current Disposition</span>
              <Whisper
                trigger="hover"
                speaker={<Tooltip>Current Disposition</Tooltip>}
              >
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <Cell dataKey="current_disposition" />
          </Column>
          <Column sortable resizable width={125}>
            <HeaderCell>
              <span>New Status</span>
              <Whisper trigger="hover" speaker={<Tooltip>New Status</Tooltip>}>
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <Cell dataKey="new_status" />
          </Column>
          <Column sortable resizable width={125}>
            <HeaderCell>
              <span>New Rate</span>
              <Whisper trigger="hover" speaker={<Tooltip>New Rate</Tooltip>}>
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <CurrencyCell dataKey="new_rate" />
          </Column>
          <Column sortable resizable width={125}>
            <HeaderCell>
              <span>New Disposition</span>
              <Whisper
                trigger="hover"
                speaker={<Tooltip>New Disposition</Tooltip>}
              >
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <Cell dataKey="new_disposition" />
          </Column>
          <Column sortable resizable width={200}>
            <HeaderCell>
              <span>Note</span>
              <Whisper trigger="hover" speaker={<Tooltip>Note</Tooltip>}>
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <Cell dataKey="note" />
          </Column>
          <Column sortable resizable width={135}>
            <HeaderCell>
              <span>Update Date</span>
              <Whisper trigger="hover" speaker={<Tooltip>Update Date</Tooltip>}>
                <Icon icon="info" style={{ marginLeft: 7 }} />
              </Whisper>
            </HeaderCell>
            <Cell dataKey="update_date" />
          </Column>
        </Table>
        {/* </FlexboxGrid.Item> */}
        {/* </FlexboxGrid> */}
      </Drawer.Body>
    </>
  );
};

export default ViewHistory;
